@for (button of stateToolbarButtons$ | async; track button) {
  @if (shouldRender(button)) {
    <button
      mat-icon-button
      [matTooltip]="button.tooltip | transloco"
      [matTooltipShowDelay]="button.tooltipShowDelay"
      [matTooltipPosition]="button.tooltipPosition"
      [disabled]="disableButton(button)"
      (click)="button.onClick()"
    >
      <mat-icon>{{ button.icon }}</mat-icon>
    </button>
  }
}
